import { CapoPlugin } from "/Users/niceloop/Desktop/Niceloop/nuxt3-mobile-order/node_modules/@unhead/vue/dist/index.mjs";
export default import.meta.server ? [CapoPlugin({ track: true })] : [];